<template>
  <div class="mb-2 sub-menu">
    <b-button
      :id="menu.routeName"
      :variant="
        $route.meta.navActiveTab == menu.active ? `primary` : `outline-primary`
      "
      v-for="menu in menus"
      :key="`menu-${menu.routeName}`"
      class="mr-1"
      @click="
        $router.push({ name: menu.routeName, params: { id: $route.params.id } })
      "
    >
      {{ $t(menu.label) }}
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: {
    BButton,
  },
  data() {
    return {
      menus: [
        {
          routeName: "update-master",
          active: "update-master",
          label: "breadcrumb.updateMaster",
        },
        {
          routeName: "list-master-block-number",
          active: "master-block-number",
          label: "breadcrumb.blockNumber",
        },
        {
          routeName: "list-master-allow-number",
          active: "master-allow-number",
          label: "breadcrumb.allowNumber",
        },
        {
          routeName: "list-master-sell-out",
          active: "master-sell-out",
          label: "breadcrumb.sellOut",
        },
        {
          routeName: "list-master-bet-setting",
          active: "master-bet-setting",
          label: "breadcrumb.betSetting",
        },
      ],
    };
  },
  mounted() {
    this.scrollToMenu();
  },
  methods: {
    scrollToMenu() {
      setTimeout(() => {
        const element = document.getElementById(this.$route.name);
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }, 200);
    },
  },
  setup() {},
};
</script>